import React, { createContext, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import "@styles/my-theme.less";
import "./App.scss";

import AppRouter from "./router/app";
import AdminRouter from "./router/admin";
import PublicRouter from "./router/public";

import LoadingComponent from "./components/loading/loading";

import AdminLoginPage from "./pages/admin/login/login";
import ProgramListPage from "./pages/admin/programList/programList";
import ProgramDetailPage from "./pages/admin/programDetail/programDetail";
import ProgramEditPage from "./pages/admin/programEdit/programEdit";
import ApplicationDetailPage from "./pages/admin/applicationDetail/applicationDetail";
import ApplicationEditPage from "./pages/admin/applicationEdit/applicationEdit";
import PaymentEditPage from "./pages/admin/paymentEdit/paymentEdit";

import ErrorPage from "./pages/error/error";
import ReceiptPage from "./pages/receipt/receipt";
import CertificatePage from "./pages/certificate/certificate";

import { PAGE } from "./utils/constants";

export const AppContext = createContext({});

function App() {
  const [loading, setLoading] = useState(false);
  const [appSetting, setAppSetting] = useState({
    checkResultForm: [],
  });
  const [adminSetting, setAdminSetting] = useState({
    enabledPaymentMethod: [
      { id: "cash", enabled: true },
      { id: "cheque", enabled: true },
    ],
  });

  return (
    <div className="App">
      <AppContext.Provider
        value={{
          appSetting,
          setAppSetting,
          setLoading,
          adminSetting,
          setAdminSetting,
        }}
      >
        {loading && <LoadingComponent />}
        <Switch>
          <Route path={PAGE.APP} component={AppRouter} />
          <PublicRouter
            exact
            path={PAGE.ADMIN_LOGIN}
            component={AdminLoginPage}
          />

          <AdminRouter
            path={PAGE.ADMIN_PROGRAM_LIST}
            component={ProgramListPage}
          />
          <AdminRouter
            exact
            path={PAGE.ADMIN_PROGRAM_DETAIL}
            component={ProgramDetailPage}
          />
          <AdminRouter
            path={PAGE.ADMIN_PROGRAM_DETAIL_EDIT}
            component={ProgramEditPage}
          />
          <AdminRouter
            exact
            path={PAGE.ADMIN_APPLICATION_DETAIL}
            component={ApplicationDetailPage}
          />
          <AdminRouter
            path={PAGE.ADMIN_APPLICATION_EDIT}
            component={ApplicationEditPage}
          />
          <AdminRouter
            path={PAGE.ADMIN_PAYMENT_EDIT}
            component={PaymentEditPage}
          />

          <PublicRouter exact path={PAGE.ERROR} component={ErrorPage} />

          <Route path={PAGE.CERTIFICATE} component={CertificatePage} />
          <Route path={PAGE.RECEIPT} component={ReceiptPage} />

          <Redirect to={PAGE.ERROR} />
        </Switch>
      </AppContext.Provider>
    </div>
  );
}

export default App;
